module.exports = "<app-object-viewer title=\"Server Capability\" [value]=\"conformance\"></app-object-viewer>"